import { useState } from 'react';

import { ModalBase } from './ModalBase';

import type React from 'react';

export interface InvisibleJustificationModalProps {
  open: boolean;
  isPending: boolean;
  /** true quando a troca de modo falhou — `role=alert`. */
  failed: boolean;
  onClose: () => void;
  onConfirm: (justification: string) => void;
}

const MIN = 1;
const MAX = 500;

/**
 * Justificativa obrigatória para entrar no modo invisível (`supervisor_monitor`,
 * D3). O backend exige `invisibleJustification` (1-500) ao mudar para esse role —
 * este modal coleta antes da troca. Guard anti duplo-submit (disabled em pending).
 */
export function InvisibleJustificationModal({
  open,
  isPending,
  failed,
  onClose,
  onConfirm,
}: InvisibleJustificationModalProps): React.JSX.Element | null {
  const [text, setText] = useState('');
  if (!open) return null;
  const len = text.trim().length;
  const canSubmit = len >= MIN && len <= MAX && !isPending;

  return (
    <ModalBase
      open={open}
      onClose={onClose}
      title="Entrar em modo invisível"
      width={520}
      footer={
        <div style={{ display: 'flex', gap: 8, marginLeft: 'auto' }}>
          <button className="btn-ghost-mini" type="button" onClick={onClose} disabled={isPending}>
            Cancelar
          </button>
          <button
            className="btn-ghost-mini btn-ghost-mini--primary"
            type="button"
            disabled={!canSubmit}
            onClick={() => {
              onConfirm(text.trim());
            }}
          >
            {isPending ? 'Aplicando…' : 'Confirmar modo invisível'}
          </button>
        </div>
      }
    >
      <div className="modal-form">
        <div className="modal-form__callout modal-form__callout--warn">
          ⚠ No modo invisível o atendente não vê que você está acompanhando. O audit log mantém o
          registro com a justificativa.
        </div>
        <label className="modal-form__field">
          <span className="modal-form__label">Justificativa (obrigatória)</span>
          <textarea
            className="modal-form__textarea"
            value={text}
            onChange={(e) => {
              setText(e.target.value);
            }}
            rows={3}
            maxLength={MAX}
            placeholder="Auditoria regulatória / suspeita de conduta a verificar sem influenciar o atendimento…"
            aria-label="Justificativa do modo invisível"
          />
          <span className="modal-form__hint">
            {len}/{MAX}
          </span>
        </label>
        {failed && (
          <div className="banner banner--danger" role="alert">
            <div className="banner__body">
              <span className="banner__title">Não foi possível entrar em modo invisível.</span>
            </div>
          </div>
        )}
      </div>
    </ModalBase>
  );
}
